import get from 'lodash/get';
import PropTypes from 'prop-types';
import {useState} from 'react';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ClearIcon from '@mui/icons-material/Clear';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {useUpdatePatientStatusMutation} from '../../redux/services/patientStatusApi';
import CustomTextField from '../common/CustomTextField';

const handleSubmit = ({put, id, onClose, onSuccess}) => async note => {
  const req = await put({id: id, body: {note}});
  if (req.data && !req.error) {
    if (onSuccess) onSuccess();
    onClose();
  }
};

const EditPatientMemoDialog = props => {
  const {isOpen, onClose} = props;
  const patientStatus = get(props, 'patient.patient_status')
  console.log('patientStatus', patientStatus);
  const [note, setNote] = useState(get(patientStatus, 'note')) || '';
  const [put, response] = useUpdatePatientStatusMutation();
  const onSubmit = handleSubmit({
    put,
    id: get(patientStatus, 'id'),
    onClose,
    onSuccess: get(props, 'onSuccess'),
  });
  return (
    <Box>
      <Dialog
       open={isOpen}
       onClose={onClose}
       fullWidth={true}
       maxWidth='sm'
       aria-labelledby="alert-dialog-title"
       aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Typography variant='h2' padding={1}>
            Edit Note
          </Typography>
          <Divider/>
          <Stack spacing={1} padding={1}>
            {get(response, 'error')
              ? <Alert severity='error'>
                There was an error processing your request. Please try again later.
              </Alert>
              : null
            }
            <CustomTextField
              type='textarea'
              multiline
              label='Note'
              placeholder='Add notes here'
              defaultValue={get(props, 'patient.patient_status.note')}
              rows={3}
              onChange={e => setNote(e.target.value)}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
          <Button onClick={() => onSubmit(note)}>Save</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

EditPatientMemoDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
}

export default EditPatientMemoDialog;
